// @ts-nocheck legacy file transformed to TS
import React from 'react'
import PropTypes from 'prop-types'
import { colors } from 'ic-snacks'

import { ScheduleAction, SchedulePromptText, ScheduleActionContainer, TileSection } from './Styles'

const primaryColor = {
  update: colors.GREEN_500,
  delete: colors.RED_500,
}

class Confirmation extends React.Component {
  static propTypes = {
    prompt: PropTypes.node.isRequired,
    confirm: PropTypes.node.isRequired,
    cancel: PropTypes.node.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    action: PropTypes.oneOf(['update', 'delete']),
  }

  block = e => e.stopPropagation()

  render() {
    const { action, prompt, confirm, cancel, onConfirm, onCancel } = this.props

    return (
      <TileSection height="28px" backgroundColor={primaryColor[action]} onClick={this.block}>
        <SchedulePromptText>{prompt}</SchedulePromptText>
        <ScheduleActionContainer>
          <ScheduleAction color={colors.WHITE} onClick={onConfirm}>
            {confirm}
          </ScheduleAction>
          <ScheduleAction color={colors.WHITE} onClick={onCancel}>
            {cancel}
          </ScheduleAction>
        </ScheduleActionContainer>
      </TileSection>
    )
  }
}

export default Confirmation
